export { default } from "./Fade.js";